// Classes
window.Utils   = require('./classes/Utils.js');
// window.Leasing = require('./classes/Leasing.js');
window.CartItems = require('./classes/CartItems.js');
// window.CompareItems = require('./classes/CompareItems.js');

require('./ui/common.js');
// require('./ui/listing.js');
// require('./ui/static-forms.js');
require('./ui/swiper_init.js');
require('./ui/popup.js');
// require('./ui/product-gallery.js');
// require('./ui/tabs.js');
require('./ui/product.js');
require('./ui/cart.js');
// require('./ui/compare.js');
require('./ui/tracking.js');
require('./ui/ajax-forms.js');
// require('./ui/sharing.js');
// require('./ui/favourite-products.js');

require('./ui/price-range.js');
require('./ui/infinity-scroll.js');
// require('./ui/multi-select.js');
// require('./ui/infinity-scroll.js');
import ProductCartComponent from './components/CartProducts.vue';
import ProductSearchComponent from './components/Search.vue';

// Init classes
Popup.init();
CartItems.init();
// CompareItems.init();

Vue.filter("format_money", function(money) {
	var number = (typeof money === "number") ? money : +money.replace(/[^\d.,]/g, '');
	money = isNaN(number) ? 0 : number.toFixed(2);
	money = ("" + money).replace("\.", ".");

	return money;
});


// Init Vue components
Vue.component(
	'cart-products', 
	ProductCartComponent
);

Vue.component(
    'product-search',
    ProductSearchComponent
);

// var SearchVue = new Vue({
// 	el: '#popup-search'
// });

// Vue.component(
//     'product-leasing',
//     require('./components/Leasing.vue').default
// );

if (document.getElementById("cart-product-leasing")) {
	var CartProductLeasing = new Vue({
		el: "#cart-product-leasing",
		
		data: {
			price: 0
		},

		methods: {
			setPrice(price) {
				this.price = price;
			}
		}
	});
}

// Instantiate component only if the element exists
if (document.getElementById("cart-products")) 
{
	var CartProducts = new Vue({
		el: '#cart-products',
	});
}

var SearchVuePopup = null;

// var LeasingVuePopup = null;

Popup.on("open", function(popup) {

	if (popup == "search") {

		SearchVuePopup = new Vue({
			el: ".popup"
		});
	}

	// if (popup == "leasing") {

	// 	LeasingVuePopup = new Vue({
	// 		el: ".popup"
	// 	});
	// }

});

Popup.on("close", function(popup) {

	if (popup == "search") {
		SearchVuePopup.$destroy();
	}

	// if (popup == "leasing") {
	// 	LeasingVuePopup.$destroy();
	// }
	
});




// $("select").tailSelect();
